<script>
  import DefaultAvatar from './DefaultAvatar.svelte';
  import { External } from '../external';

  export let author;

  const hasAvatar = !!author.extra?.avatar;
  const avatarStyle = hasAvatar
    ? `background-image:url('${External.getThumbnailsFromBase(author.extra.avatar.base + '/', '72x50', true) + author.extra.avatar.name}')`
    : '';
</script>

{#if hasAvatar}
  <div class="circle-post-author-image" style={avatarStyle}></div>
{:else}
  <DefaultAvatar wrapperClasses="circle-post-author-image" identifier={author.memberId} name={author.name} />
{/if}
